module.exports = __webpack_public_path__ + "img/vertical_4_6_8019.ed4a9a2a.png";